/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/paging/book',['require','underscore','backbone','modules/paging/page','modules/paging/paging-object'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var Backbone = require('backbone');
  var Page = require('modules/paging/page');
  var PagingObject = require('modules/paging/paging-object');

  /*****************************************************************************************************************///}

  var Book = PagingObject.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    defaults: function()
    {
      var inherited = PagingObject.prototype.defaults.apply(this, arguments);

      return _.assign(inherited, {
        content          : null,
        position         : 0,
        percGold      : 0.95,
        percSilver    : 0.9,
        percBronze    : 0.8,
        scorePointModifier : 100,
        type               : 'module'
      });
    },

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(data)
    {
      PagingObject.prototype.initialize.apply(this, arguments);

      ////console.log("Book initialize");
      ////console.log(this);
      this.content = new PagingCollection(this.get('content'));
      this.content.on('change', this.onContentChanged, this);
      this.content.parent = this; // is this necessary?

      if (this.get('id') === 'individual-pages')
      {
        _.each(this.content.models, function($page) {
          $page.set('inOverlay', true);
        }, this);
      }

      if (this.get('filter'))
      {
        var filterArr = this.get('filter').split('-');
        var level = filterArr[1] && !isNaN(parseInt(filterArr[1])) ? parseInt(filterArr[1]) : 0;
        this.set('level', level);
      }
      else
      {
        this.set('level', 0);
      }
    },

    setRequirements: function()
    {
      var self = this;
      this.content.each(function(pagingObject, index)
      {
        if (pagingObject.get('requirements') === undefined) // if no requirements set
        {
          if (index === 0) // first item has same as parent
            pagingObject.set('requirements', self.get('requirements'));
          else // everything else is prev object
            pagingObject.set('requirements', [self.content.at(index - 1).get('id')]);
        }

        // chain the call
        pagingObject.setRequirements();
      });
    },

    onContentChanged: function(e)
    {
      ////console.log('Book::onContentChanged');

      /*if (!this.get('complete')) // check for completion
      {
        var complete = this.content.every(function(obj) {
          return obj.get('complete') || !obj.get('required');
        });

        if (complete)
          this.finish();
      }*/
    },

    checkLocks: function()
    {
      PagingObject.prototype.checkLocks.apply(this, arguments);

      ////console.log(this.content);

      this.content.invoke('checkLocks');
    },

    unlock: function()
    {
      PagingObject.prototype.unlock.apply(this, arguments);

      // also unlock first item
      //this.content.at(0).unlock();
    },

    lock: function()
    {
      PagingObject.prototype.lock.apply(this, arguments);

      // also lock children
      this.content.invoke('lock');
    },

    setActive: function(index)
    {
      if (!_.isUndefined(index))
        this.set('position', index);

      PagingObject.prototype.setActive.apply(this, arguments);
    },

    atEnd: function()
    {
      return (this.get('position') >= this.content.length - 1);
    },

    atBeginning: function()
    {
      return (this.get('position') === 0);
    },

    next: function()
    {
      return this.content.models[this.get('position') + 1];
    },

    prev: function()
    {
      return this.content.models[this.get('position') - 1];
    },

    first: function()
    {
      var result;

      if (this.content.length)
      {
        var currentObject = this.content.models[0];
        if (currentObject instanceof Book)
          result = currentObject.first();
        else
          result = currentObject;
      }

      return result;
    },

    current: function()
    {
      var result;

      if (this.content.length)
      {
        var currentObject = this.content.models[this.get('position')];
        if (currentObject instanceof Book)
          result = currentObject.current();
        else
          result = currentObject;
      }

      return result;
    },

    find: function(id)
    {
      var isSelf = PagingObject.prototype.find.apply(this, arguments);

      if (isSelf)
        return this;

      var result;
      this.content.each(function(obj, index)
      {
        result = result || obj.find(id);
      });

      return result;
    },

    getPages: function()
    {
      var pages = [];//this.content.clone().models;
      this.content.each(function(obj)
      {
        pages.push(obj.getPages());
      });

      return _.flatten(pages, true);
    },

    gradeModule: function()
    {
      console.log('gradeModule');
      var $maxPoints = 0;
      var $earnedPoints = 0;

      _.each(this.getPages(), function($page) {
        //console.log('page', $page);
        $maxPoints += $page.get('maxPoints');
        $earnedPoints += $page.get('earnedPoints');
      }, this);

      this.set('netPoints', $earnedPoints - this.get('earnedPoints'));
      this.set('maxPoints', $maxPoints);

      if ($earnedPoints > this.get('earnedPoints'))
      {
        this.set('improvedResult', true);
        this.set('earnedPoints', $earnedPoints);
      }
      this.set('maxPoints', $maxPoints);
      this.set('earnedPoints', Math.max(this.get('earnedPoints'), $earnedPoints));

      //console.log('grade mod', $earnedPoints, this.get('earnedPoints'));
      if (this.seen())
      {
        this.finish();
        this.set('active', false);
      }
      /*
        REMOVED 5/19 per ARC
        if ((this.get('level') !== 3 && this.seen()) || this.isComplete())
      {
        this.finish();
        this.set('active', false);
      }*/
    },

    seen: function()
    {
      return (this.get('maxPoints') > 0) ? true : false;
    },

    status: function()
    {
      var status = 'incomplete';
      /*
      REMOVED 5/19 per ARC
      if (this.isComplete() || (this.seen() && this.get('level') !== 3))
        status = 'complete';
      else if (this.get('level') === 3 && !this.isComplete() && this.seen())
        status = 'retry';*/
      if (this.seen())
        status = 'complete';

      return status;
    },

    isComplete: function()
    {
      return (this.medal() !== 'medal_none' && this.medal() !== 'medal_locked');
      //return (_earnedPoints !== -1);
    },

    isGold: function()
    {
      return (this.medal() === 'medal_gold');
    },

    medal: function()
    {
      var $medal = 'medal_none';
      ////console.log('medal()', this.earnedPerc());
      ////console.log(this.get('maxPoints'), this.get('earnedPoints'), this.get('maxPoints'));

      if (!this.seen())
      {
        $medal = 'medal_locked';
      }
      else if (this.earnedPerc() >= this.get('percGold'))
      {
        $medal = 'medal_gold';
      }
      else if (this.earnedPerc() >= this.get('percSilver'))
      {
        $medal = 'medal_silver';
      }
      else if (this.earnedPerc() >= this.get('percBronze'))
      {
        $medal = 'medal_bronze';
      }

      return $medal;
    },

    earnedPerc: function()
    {
      return (this.get('maxPoints') > 0) ? (this.get('earnedPoints') / this.get('maxPoints')) : 0;
    },

    serialize: function()
    {
      ////console.log('bookmark book', this);
      var data = {
        c: this.get('complete') === true ? 1 : 0,
        l: this.get('locked') === true ? 1 : 0,
        //position: this.get('position'),
        //status: this.get('status'),
        ep: Math.round(this.get('earnedPoints') * 100) / 100,//.toFixed(2),
        mp: Math.round(this.get('maxPoints') * 100) / 100
      };

      if (_.size(this.get('storage')))
        data.storage = this.get('storage');

      if (this.content.length)
      {
        if (_.some(this.content.models, {'attributes': {'type': 'module'}}) || _.some(this.content.models, {'attributes': {'bookmark': true}}))
        {
          ////console.log('has sub items');
          data.content = { };
          this.content.each(function(obj)
          {
            if (obj.get('type') === 'page' && obj.get('bookmark') !== true)
              return;

            data.content[obj.id] = obj.serialize();
          });
        }
      }

      return data;
    },

    deserialize: function(data)
    {
      var obj;

      // handle children
      for (var id in data.content)
      {
        obj = this.content.get(id);

        if (obj)
          obj.deserialize(data.content[id]);
      }

      delete data.content;

      // for (var prop in data)
      // {
      //   this.set(prop, data[prop], { silent: true });
      // }
      if (data.c === 1)
      {
        this.set('complete', true, { silent: true });
        this.set('status', 'complete', { silent: true });
        if (data.mp === 0)
        {
          this.set('earnedPoints', 10);
          this.set('maxPoints', 10);
        }
      }

      //this.set('complete', data.complete === 1);
      if (data.l === 0)
        this.unlock();
      /*if (this.get('locked'))
        this.set('locked', data.l === 1, { silent: true });*/
      //this.set('position', data.position);
      //this.set('status', data.status);
      if (!this.get('earnedPoints') || data.ep > this.get('earnedPoints'))
        this.set('earnedPoints', data.ep, { silent: true });

      if (!this.get('maxPoints') || data.mp > this.get('maxPoints'))
        this.set('maxPoints', data.mp, { silent: true });
    },

    finish: function()
    {
      console.error('book finish');
      PagingObject.prototype.finish.apply(this, arguments);
    }

  /*****************************************************************************************************************///}

  });

  ////////////////
  // AUXILLIARY /{
  ////////////////

  var PagingCollection = Backbone.Collection.extend({

    parent: null,

    model: function(attrs, options)
    {
      if (attrs.content)
        return new Book(attrs, options);
      else
      {
        return new Page(attrs, options);
      }
    }

  });

  /*****************************************************************************************************************///}

  return Book;

});

